export default __webpack_public_path__ + "5dff18daa931900076e3ee0963a07139.svg";